import AzqpMap from './AzqpMap';
import ArrlSectionsMap from './ArrlSectionsMap';
import { getContestDefinition } from './contests/registry';

function ContestMap({ contestSlug = 'field-day', ...props }) {
  const ruleset = getContestDefinition(contestSlug)?.ruleset || 'field-day';

  if (ruleset === 'azqp') {
    return <AzqpMap {...props} />;
  }

  return <ArrlSectionsMap {...props} />;
}

export default ContestMap;
